import { Alert, Button, Stack } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import LibraryRow from './LibraryRow';
import LibraryTabPanel from './LibraryTabPanel';
import type { SkillLibraryEntryPage } from './types';

type CommunitySkillsTabProps = {
  page: SkillLibraryEntryPage | undefined;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  onOpen: (entryId: string) => void;
};

export default function CommunitySkillsTab({
  page,
  isLoading,
  isError,
  onRetry,
  onOpen,
}: CommunitySkillsTabProps) {
  const items = page?.items ?? [];

  return (
    <Stack gap="md">
      <Alert variant="light" color="gray" icon={<IconAlertTriangle size={16} />}>
        Shared by other firms using Afternoon. These have not been checked by Afternoon, so read a
        skill before you add it.
      </Alert>
      <LibraryTabPanel
        tabLabel="community skills"
        isLoading={isLoading}
        isError={isError}
        onRetry={onRetry}
        isEmpty={items.length === 0}
        emptyTitle="No community skills yet"
        emptyBody="Nobody has shared a skill yet. If your firm has one worth passing on, you can share it from your own skills."
      >
        {items.map(entry => (
          <LibraryRow
            key={entry.id}
            entry={entry}
            action={
              <Button variant="default" onClick={() => onOpen(entry.id)}>
                Read skill
              </Button>
            }
          />
        ))}
      </LibraryTabPanel>
    </Stack>
  );
}
